import { render, staticRenderFns } from "./DepartmentNewButton.vue?vue&type=template&id=7a65bfd2&scoped=true&"
import script from "./DepartmentNewButton.vue?vue&type=script&lang=ts&"
export * from "./DepartmentNewButton.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentNewButton.vue?vue&type=style&index=0&id=7a65bfd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a65bfd2",
  null
  
)

export default component.exports